<template>
  <div>
    <view-options elementId="GoogleDisplay" />
    <div class="product-view" id="GoogleDisplay">
      <div class="youtube-wrapper" id="Youtube">
        <div class="lds-ellipsis" v-if="loadingData">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>

        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            v-if="isDPAvailable || (!isAPPAvailable && !isRPAAvailable && !isALLAvailable)"
            label="Portales"
            name="first"
          >
            <section class="widget widget-goals">
              <h3 class="widget-title">
                ¿Qué logró su publicidad en la red de Google?
              </h3>
              <div class="cards-wrapper">
                <card type="goals">
                  <div class="card-header">
                    <div class="icon-wrapper">
                      <font-awesome-icon icon="eye" />
                    </div>
                    <h4 class="card-title">Impresiones</h4>
                  </div>
                  <div class="card-content">
                    <h1>
                      {{ numberLetter(productData.totalImpressions) }}
                    </h1>
                    <p>
                      Cantidad de veces que su publicidad fue expuesta a su
                      público objetivo
                    </p>
                  </div>
                </card>
                <card type="goals">
                  <div class="card-header">
                    <div class="icon-wrapper">
                      <font-awesome-icon icon="eye" />
                    </div>
                    <h4 class="card-title">Clicks</h4>
                  </div>
                  <div class="card-content">
                    <h1>{{ numberLetter(productData.totalClicks) }}</h1>
                    <p>
                      Interaciones con la audiencia
                    </p>
                  </div>
                </card>
              </div>
              <section class="widget brand-impact">
                <h3 class="widget-title">
                  El impacto de su marca en el tiempo
                </h3>
                <card type="line-chart">
                  <div class="card-top">
                    <div class="card-header">
                      <h4 class="card-title">Impresiones</h4>
                    </div>
                  </div>
                  <div class="card-content">
                    <impressions
                      :totalImpressions="Product.totalImpressions || 0"
                      :impressions="Product.impressions || []"
                      :clicks="Product.clicks || []"
                      :imp="impressionsChartOptions"
                    ></impressions>
                  </div>
                </card>
              </section>
            </section>

            <mq-layout mq="laptop+">
              <section class="mobile-canvas">
                <img src="@/assets/images/google-display-phone.png" alt />
              </section>
            </mq-layout>
            <section class="widget ad-sites-widget">
              <div v-if="adSites.length !== 0">
                <h3 class="widget-title">
                  ¿Dónde aparecieron sus anuncios en la web?
                </h3>
                <card>
                  <div class="ad-sites-wrapper">
                    <div
                      class="sites"
                      v-for="(adSites, index) in adSites.slice(0, mas)"
                      :key="index"
                    >
                      <img
                        id="logo"
                        class="logo"
                        :src="adSites.logo"
                        @error="CHANGE_IMAGE"
                        alt="logo"
                      />
                      <h4 class="nameSite">{{ adSites.name }}</h4>
                      <div class="site-data">
                        <div>
                          <h6>{{ adSites.impressions.toLocaleString() }}</h6>
                          <p>Impresiones</p>
                        </div>
                        <div>
                          <h6>{{ adSites.clicks.toLocaleString() }}</h6>
                          <p>Clicks</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="show">
                    <br />
                    <button @click="collapse" v-show="showMessage">
                      Ver {{ Message }}
                    </button>
                  </div>
                </card>
              </div>
            </section>
          </el-tab-pane>
          <el-tab-pane v-if="isAPPAvailable" label="Aplicaciones" name="second">
            <section class="widget widget-goals">
              <h3 class="widget-title">
                ¿Qué logró su publicidad en la red de Google?
              </h3>
              <div class="cards-wrapper">
                <card type="goals">
                  <div class="card-header">
                    <div class="icon-wrapper">
                      <font-awesome-icon icon="eye" />
                    </div>
                    <h4 class="card-title">Impresiones</h4>
                  </div>
                  <div class="card-content">
                    <h1>
                      {{ numberLetter(productData.totalAppImpressions) }}
                    </h1>
                    <p>
                      Cantidad de veces que su publicidad fue expuesta a su
                      público objetivo
                    </p>
                  </div>
                </card>
                <card type="goals">
                  <div class="card-header">
                    <div class="icon-wrapper">
                      <font-awesome-icon icon="eye" />
                    </div>
                    <h4 class="card-title">Clicks</h4>
                  </div>
                  <div class="card-content">
                    <h1>{{ numberLetter(productData.totalAppClicks) }}</h1>
                    <p>
                      Interaciones con la audiencia
                    </p>
                  </div>
                </card>
              </div>
              <section class="widget brand-impact">
                <h3 class="widget-title">
                  El impacto de su marca en el tiempo
                </h3>
                <card type="line-chart">
                  <div class="card-top">
                    <div class="card-header">
                      <h4 class="card-title">Impresiones</h4>
                    </div>
                  </div>
                  <div class="card-content">
                    <impressions
                      :totalImpressions="Product.totalImpressions || 0"
                      :impressions="Product.impressions || []"
                      :imp="impressionsChartOptions"
                      :clicks="Product.clicks || []"
                    ></impressions>
                    <!-- :labelType="'Clicks'" -->
                  </div>
                </card>
              </section>
            </section>
            <mq-layout mq="laptop+">
              <section class="mobile-canvas">
                <img src="@/assets/images/google-display-phone-apps.png" alt />
              </section>
            </mq-layout>
          </el-tab-pane>
          <el-tab-pane v-if="isRPAAvailable" label="Responsive" name="third">
            <section class="widget widget-goals">
              <h3 class="widget-title">
                ¿Qué logró su publicidad en la red de Google?
              </h3>
              <div class="cards-wrapper">
                <card type="goals">
                  <div class="card-header">
                    <div class="icon-wrapper">
                      <font-awesome-icon icon="eye" />
                    </div>
                    <h4 class="card-title">Impresiones</h4>
                  </div>
                  <div class="card-content">
                    <h1>
                      {{ numberLetter(productData.totalRpaImpressions) }}
                    </h1>
                    <p>
                      Cantidad de veces que su publicidad fue expuesta a su
                      público objetivo
                    </p>
                  </div>
                </card>
                <card type="goals">
                  <div class="card-header">
                    <div class="icon-wrapper">
                      <font-awesome-icon icon="eye" />
                    </div>
                    <h4 class="card-title">Clicks</h4>
                  </div>
                  <div class="card-content">
                    <h1>{{ numberLetter(productData.totalRpaClicks) }}</h1>
                    <p>
                      Interaciones con la audiencia
                    </p>
                  </div>
                </card>
              </div>
              <section class="widget brand-impact">
                <h3 class="widget-title">
                  El impacto de su marca en el tiempo
                </h3>
                <card type="line-chart">
                  <div class="card-top">
                    <div class="card-header">
                      <h4 class="card-title">Impresiones</h4>
                    </div>
                  </div>
                  <div class="card-content">
                    <impressions
                      :totalImpressions="Product.totalImpressions || 0"
                      :impressions="Product.impressions || []"
                      :imp="impressionsChartOptions"
                      :clicks="Product.clicks || []"
                      :labelType="'Clicks'"
                    ></impressions>
                  </div>
                </card>
              </section>
            </section>
            <mq-layout mq="laptop+">
              <section class="mobile-canvas">
                <img src="@/assets/images/google-display-phone-apps.png" alt />
              </section>
            </mq-layout>
          </el-tab-pane>
        </el-tabs>
      </div>

      <section class="widget campaign-widget">
        <h3 class="widget-title">Campañas</h3>
        <card>
          <table class="table">
            <thead>
              <th>Campaña</th>
              <th>Impresiones</th>
              <th>Clicks</th>
              <th>CTR</th>
              <th>CPM</th>
            </thead>
            <tbody>
              <tr v-for="(campaignData, index) in campaignData" :key="index">
                <td>{{ campaignData.name }}</td>
                <td>{{ Number(campaignData.impressions).toLocaleString() }}</td>
                <td>{{ Number(campaignData.clicks).toLocaleString() }}</td>
                <td>{{ campaignData.ctr.toFixed(2) }}%</td>
                <td>{{ campaignData.cpm.toFixed(2) }}</td>
              </tr>
            </tbody>

            <thead>
              <tr>
                <th>Total</th>
                <th>{{ TotalCampains.Impresiones.toLocaleString() }}</th>
                <th>{{ TotalCampains.Clicks.toLocaleString() }}</th>
                <th>{{ TotalCampains.CTR.toFixed(2).toLocaleString() }}%</th>
                <th>{{ TotalCampains.CPM.toFixed(2).toLocaleString() }}</th>
              </tr>
            </thead>
          </table>
        </card>
      </section>

      <section v-if="AllConversionActions.length" class="widget campaign-widget">
        <h3 class="widget-title">Resumen de Conversions</h3>
        <conversion-table :conversionArray="AllConversionActions" />
      </section>

      <section class="widget ad-sites-widget">
        <div v-if="adSites.length !== 0 && campaignType == 'APP'">
          <h3 class="widget-title">
            Top 20 categorías de aplicaciones donde aparecieron sus anuncios
          </h3>

          <card>
            <table class="table">
              <thead>
                <th>Categoría</th>
                <th>Impresiones</th>
                <th>Clicks</th>
              </thead>
              <tbody>
                <tr
                  v-for="(adSites, index) in adSites.slice(0, masApp)"
                  :key="index"
                >
                  <td>{{ adSites.name }}</td>
                  <td>
                    {{ adSites.impressions.toLocaleString() }}
                  </td>
                  <td>
                    {{ adSites.clicks.toLocaleString() }}
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="show">
              <br />
              <button @click="collapse" v-show="showMessage">
                Ver {{ Message }}
              </button>
            </div>
          </card>
        </div>
      </section>

      <div
        class="widget-area audience-report one-column"
        v-if="audienceInteractionSeries && audienceInteractionSeries.length > 0"
      >
        <section class="widget" style="margin: 0 0">
          <h3 class="widget-title" style="text-align: center"> Interacción de sus audiencias </h3>
          <card>
            <apexchart
              type="pie"
              width="380"
              :options="audienceInteractionChartOptions"
              :series="audienceInteractionSeries"
            />
          </card>
        </section>
      </div>
      <p style="font-style: italic; margin-bottom: 50px; text-align: center">
        Se muestran los resultados de mayor volumen con un límite de 5 elementos
      </p>
      <div class="widget-area demographic-data">
        <h3 class="widget-title">Datos demográficos sobre sus usuarios</h3>
        <section class="widget">
          <h5 class="widget-title">Edad</h5>
          <card>
            <ApexchartBar
              type="bar"
              height="350"
              :headers="genderChartOptions.xaxis.categories"
              :series="genderSeries[0].data"
              :bar="true"
            />
          </card>
        </section>

        <section class="widget">
          <h5 class="widget-title">Género</h5>
          <card>
            <ApexchartBar
              type="bar"
              height="350"
              :headers="ageChartOptions.xaxis.categories"
              :series="ageSeries[0].data"
              :bar="true"
            />
          </card>
        </section>
        <section class="widget">
          <h5 class="widget-title">Dispositivos</h5>
          <card>
            <ApexchartBar
              type="bar"
              height="350"
              :headers="devicesChartOptions.xaxis.categories"
              :series="devicesSeries[0].data"
              :bar="false"
            />
          </card>
        </section>
      </div>
      <section class="ads-container">
        <div class="widget ad-views" v-if="adsBanners.length > 0">
          <h3 class="widget-title">Un vistazo a sus anuncios en Display</h3>
          <div class="cards-wrapper">
            <div class="widget ad-views">
              <div class="cards-wrapper">
                <ad-banners
                  :adsBanners="adsBanners"
                  v-if="adsBanners.length > 0"
                ></ad-banners>
              </div>
            </div>
          </div>
        </div>
        <div v-if="videosAdsURL.length > 0">
          <h3 class="widget-title">
            Este es el desempeño de sus anuncios en YouTube
          </h3>
          <div class="widget-area two-column">
            <div class=" ad-views">
              <div class="">
                <card class="ad-listing">
                  <el-carousel
                    :interval="5000"
                    arrow="always"
                    indicator-position="none"
                    class="carousel-youtube"
                  >
                    <el-carousel-item
                      v-for="(videoAdsURL, index) in videosAdsURL"
                      :key="index"
                    >
                      <div class="youtube-header">
                        <img src="@/assets/images/youtube-logo.svg" alt />
                        <div class="header-buttons">
                          <font-awesome-icon icon="search" />
                        </div>
                      </div>
                      <div class="youtube-viewport" v-if="videoAdsURL">
                        <iframe
                          width="100%"
                          height="100%"
                          :src="videoAdsURL.replace('embed/', 'watch?v=')"
                          frameborder="0"
                          scrolling="no"
                        ></iframe>
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                </card>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="export" id="export"></div>
  </div>
</template>
<script>
import ViewOptions from "@/components/ViewOptions.vue";
import Impressions from "@/components/ApexchartCustom/Impressions.vue";
import AdBanners from "@/components/Widgets/YourAds/AdBanners.vue";
import ApexchartBar from "../../components/ApexchartCustom/ApexchartBar";
import ConversionTable from "../../components/ConversionTable";
import { mapGetters } from "vuex";
import img from "../../assets/images/logoGenerico.png";

// REQUEST
import adwordsGoogleDisplay from "../../services/Fase2/adwordGoogleDisplay";
import { validateProductExpirationDate } from "../../util";
import { BUSINESS_UNIT_ID } from "../../constants";

export default {
  name: "google-display",
  components: {
    ViewOptions,
    Impressions,
    AdBanners,
    ApexchartBar,
    ConversionTable
  },
  data() {
    return {
      campaignTypes: {
        Todos: "ALL",
        Portales: "DP",
        PortalesTypeFromDB: "DPL",
        Aplicaciones: "APP",
        Responsive: "RPA"
      },
      campaignsData: {
        todos: {},
        portales: {},
        portalesTypeFromDB: {},
        aplicaciones: {},
        responsive: {}
      },
      ConversionActions: [],
      AllConversionActions: [],
      isDPAvailable: false,
      isAPPAvailable: false,
      isRPAAvailable: false,
      isALLAvailable: false,
      loadingData: false,
      campaignType: "DP",
      activeName: "first",
      businessUnit: 1,
      showMessage: false,
      mas: 8,
      masApp: 8,
      Message: "más +",
      Product: [],
      TotalCampains: {
        Impresiones: 0,
        Clicks: 0,
        CTR: 0,
        CPC: 0,
        CPM: 0
      },
      productData: {
        totalImpressions: 0,
        totalClicks: 0
      },
      keywordData: [
        {
          keyword: "ventana",
          impressions: 212575,
          clicks: 2212
        },
        {
          keyword: "Cristales",
          impressions: 199977,
          clicks: 1538
        },
        {
          keyword: "Enmarcados",
          impressions: 179328,
          clicks: 94
        },
        {
          keyword: "construccion en republica dominicana",
          impressions: 65232,
          clicks: 542
        },
        {
          keyword: "Grabados",
          impressions: 26463,
          clicks: 723
        }
      ],
      adSites: [],
      videosAdsURL: [],
      campaignData: [],
      impressionsSeries: [
        {
          name: "Impresiones",
          data: []
        },
        {
          name: "Clicks",
          data: []
        }
      ],
      PRimpressionsSeries: [
        {
          name: "Impresiones",
          data: []
        }
      ],
      impressionsChartOptions: {
        tooltip: {
          x: {
            show: true,
            format: "dd MMM",
            formatter: undefined
          },

          y: {
            formatter: function(
              value
              // { series, seriesIndex, dataPointIndex, w }
            ) {
              return value.toLocaleString();
            }
          }
        },
        responsive: [
          {
            breakpoint: undefined,
            options: {
              width: "100%"
            }
          }
        ],
        chart: {
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 3,
          // width: [5, 7, 5],
          curve: "smooth"
        },
        markers: {
          size: 0,

          hover: {
            sizeOffset: 6
          }
        },
        xaxis: {
          categories: [
            "Jun '18",
            "Ago '18",
            "Oct '18",
            "Dic '18",
            "Feb '18",
            "Abr '18"
          ]
        },
        grid: {
          borderColor: "#f1f1f1"
        }
      },
      audienceInteractionSeries: [],
      audienceInteractionChartOptions: {
        colors: [
          "#0A286E",
          "#0E3593",
          "#1248C9",
          "#3772FF",
          "#08ACFF",
          "#93ABE6",
          "#BECDF0"
        ],
        labels: [],
        legend: {
          position: "bottom"
        },
        responsive: [
          {
            breakpoint: undefined,
            options: {
              width: "100%"
            }
          }
        ]
      },
      interestTopicsSeries: [],
      interestTopicsChartOptions: {
        colors: [
          "#0A286E",
          "#0E3593",
          "#1248C9",
          "#3772FF",
          "#08ACFF",
          "#93ABE6",
          "#BECDF0"
        ],
        labels: [],
        legend: {
          position: "bottom"
        },
        responsive: [
          {
            breakpoint: undefined,
            options: {
              width: "100%"
            }
          }
        ]
      },
      genderSeries: [
        {
          data: []
        }
      ],
      genderChartOptions: {
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        chart: {
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        }
      },
      ageSeries: [
        {
          data: []
        }
      ],
      ageChartOptions: {
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        chart: {
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        }
      },
      devicesSeries: [
        {
          data: []
        }
      ],
      devicesChartOptions: {
        plotOptions: {
          bar: {
            horizontal: false
          }
        },
        chart: {
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        }
      },
      adsBanners: [],
      adBannerImages: [],
      index: null,
      appRegexPattern: /^([A-z0-9 ]+(AP{2}|ap{2})|Ap{1,2}lica(c|t)i(o|ó)n)/g,
      rpaRegexPattern: new RegExp("RPA", "i")
    };
  },
  watch: {
    date1: {
      handler() {
        this.reload(this);
      },
      deep: true
    },

    date2: {
      handler() {
        this.reload(this);
      },
      deep: true
    }
  },
  async created() {
    const context = this;
    this.reload(context);
  },

  methods: {
    CHANGE_IMAGE(e) {
      e.target.src = img;
    },
    reload: async function(context) {
      this.loadingData = true;
      context.productData.totalImpressions = 0;
      context.productData.totalClicks = 0;
      context.productData.totalAppImpressions = 0;
      context.productData.totalAppClicks = 0;
      context.productData.totalRpaImpressions = 0;
      context.productData.totalRpaClicks = 0;

      context.ageSeries[0].data = [];
      context.genderSeries[0].data = [];
      context.devicesSeries[0].data = [];

      context.ageChartOptions.xaxis.categories = [];
      context.genderChartOptions.xaxis.categories = [];
      context.devicesChartOptions.xaxis.categories = [];

      context.videosAdsURL = [];

      context.audienceInteractionSeries = [];
      context.audienceInteractionChartOptions.labels = [];

      context.TotalCampains.Impresiones = 0;
      context.TotalCampains.Clicks = 0;
      context.TotalCampains.CTR = 0;
      context.TotalCampains.CPC = 0;
      context.TotalCampains.CPM = 0;
      context.campaignData = [];

      let { businessUnitId, subscriberId, productId } = context.$route.params;
      const { customerId } = context.$route.query;

      const products = context.$store.state.subscriber.products;
      const validatedFinalDate = validateProductExpirationDate(products,productId,context.$store.state.subscriber.date1)

      let fromDate = context.$store.state.subscriber.date2 > validatedFinalDate ? validatedFinalDate : context.$store.state.subscriber.date2;
      let toDate = validatedFinalDate;

      context.businessUnit = businessUnitId;
      const objCampaigns = [];
      let objAdSites = [];
      const objAdsBanners = [];
      const product = {
        clicks: [],
        impressions: [],
        totalImpressions: 0
      };

      // businessUnitId = BUSINESS_UNIT_ID.IP;

      // Las campañas de Display en infomedia no llevan la nomenclatura de Axesa o Caribe Media, 
      // Por lo que se valida y se trae la sumarización de las métricas

      if (businessUnitId == BUSINESS_UNIT_ID.IP) {
        this.campaignsData.todos = await new adwordsGoogleDisplay(
          context
        ).getGoogleDisplay(
          subscriberId,
          businessUnitId,
          fromDate,
          toDate,
          customerId,
          this.campaignTypes.Todos
        );
      }

      this.campaignsData.portales = await new adwordsGoogleDisplay(
        context
      ).getGoogleDisplay(
        subscriberId,
        businessUnitId,
        fromDate,
        toDate,
        customerId,
        this.campaignTypes.Portales
      );

      this.campaignsData.aplicaciones = await new adwordsGoogleDisplay(
        context
      ).getGoogleDisplay(
        subscriberId,
        businessUnitId,
        fromDate,
        toDate,
        customerId,
        this.campaignTypes.Aplicaciones
      );

      this.campaignsData.responsive = await new adwordsGoogleDisplay(
        context
      ).getGoogleDisplay(
        subscriberId,
        businessUnitId,
        fromDate,
        toDate,
        customerId,
        this.campaignTypes.Responsive
      );

      if (this.campaignsData.responsive && this.campaignsData.responsive.totalImpressions)
        this.isRPAAvailable = true;
      if (this.campaignsData.portales && this.campaignsData.portales.totalImpressions)
        this.isDPAvailable = true;
      if (this.campaignsData.aplicaciones && this.campaignsData.aplicaciones.totalImpressions)
        this.isAPPAvailable = true;
      if (this.campaignsData.todos && this.campaignsData.todos.totalImpressions)
        this.isALLAvailable = true;

      if (this.isAPPAvailable && !this.isDPAvailable && !this.isRPAAvailable) {
        this.activeName = "second";
        this.campaignType = this.campaignTypes.Aplicaciones;
      }

      if (this.isALLAvailable) {
        this.campaignType = this.campaignTypes.Todos;
      }

      if (this.isRPAAvailable && !this.isDPAvailable && !this.isAPPAvailable) {
        this.activeName = "third";
        this.campaignType = this.campaignTypes.Responsive;
      }

      //Si el tab activo tiene data, no volvemos a realizar la petición porque ya tenemos esa data.
      let googleDisplay =
        this.campaignType == this.campaignTypes.Responsive ? this.campaignsData.responsive
        : this.campaignType == this.campaignTypes.Aplicaciones ? this.campaignsData.aplicaciones
        : this.campaignType == this.campaignTypes.Todos ? this.campaignsData.todos
          : this.campaignsData.portales;

       //---------------------------------------------------------------------------------------------------

      this.loadingData = false;

      if (!googleDisplay) {
        return;
      }

      const conversionActions = [];

      context.ConversionActions = googleDisplay.conversionActions;

      if (context.ConversionActions.length > 0) {
        context.ConversionActions.map(({ conversionActionRows }) => {
          return conversionActionRows.map(actions => {
            conversionActions.push({
              allConversion: actions.allConversion,
              conversionAction: actions.conversionAction
            });
          });
        });
      }

      context.AllConversionActions = conversionActions;

      // Spliting DPL, RPA and APP impressions
      (googleDisplay.campaigns || []).forEach(element => {
        if (element.campaignname.match(this.appRegexPattern)) {
          context.productData.totalAppImpressions += parseInt(element.impressions)
          context.productData.totalAppClicks += parseInt(element.clicks);
        } else if (element.campaignname.match(this.rpaRegexPattern)) {
          context.productData.totalRpaImpressions += parseInt(element.impressions);
          context.productData.totalRpaClicks += parseInt(element.clicks);
        } else {
          context.productData.totalImpressions += parseInt(element.impressions);
          context.productData.totalClicks += parseInt(element.clicks);
        }
      });

      // impressions and clicks
      (googleDisplay.impressionsAndClicks || []).forEach(element => {
        context.impressionsSeries[0].data.push(element.impressions);
        context.impressionsSeries[1].data.push(element.clicks);
        context.impressionsChartOptions.xaxis.categories.push(element.date);

        product.clicks.push({ count: element.clicks, date: element.date });
        product.impressions.push({
          count: element.impressions,
          date: element.date
        });
      });

      // age
      (googleDisplay.ages || []).forEach(element => {
        if (element.criteria) {
          context.ageChartOptions.xaxis.categories.push(element.criteria);
          context.ageSeries[0].data.push(element.impressions);
        }
      });

      // gender
      (googleDisplay.genders || []).forEach(element => {
        if (element.criteria) {
          const filterCriteria = element.criteria.replace("to"," to ")
          context.genderChartOptions.xaxis.categories.push(filterCriteria);
          context.genderSeries[0].data.push(element.impressions);
        }
      });
      //DEVICE
      (googleDisplay.devices || []).forEach(element => {
        if (element.criteria) {
          if (element.criteria.includes("Devices")) {
            context.devicesChartOptions.xaxis.categories.push("TV");
          } else {
            context.devicesChartOptions.xaxis.categories.push(
              element.criteria.split(" ")[0]
            );
          }
          context.devicesSeries[0].data.push(element.impressions);
        }
      });
      // CAMPAIGN
      (googleDisplay.campaigns || []).forEach(element => {
        objCampaigns.push({
          name: element.campaignname,
          impressions: element.impressions,
          clicks: element.clicks,
          ctr: element.ctr,
          cpm: element.cpm
        });
      });

      context.TotalCampains.Impresiones = googleDisplay.totalImpressions;
      context.TotalCampains.Clicks = googleDisplay.totalClicks;
      context.TotalCampains.CTR = googleDisplay.totalCtr;
      context.TotalCampains.CPC = googleDisplay.totalCpc;
      context.TotalCampains.CPM = googleDisplay.totalCpm;

      // PACEMENTS
      (googleDisplay.placements || []).forEach(element => {
        if (!element.placement.toLowerCase().includes("app:")) {
          objAdSites.push({
            name: element.placement,
            logo: element.logoUrl,
            impressions: element.impressions,
            clicks: element.clicks
          });
        }
      });

      //ADS
      (googleDisplay.ads || []).forEach(element => {
        if (element.imageadurl && element.imageadurl.includes("http")) {
          objAdsBanners.push({
            bannerURL: element.imageadurl,
            itemCode: "300 x 250"
          });
        }
        if (element.videoAdIdsResponsive.length > 0) {
          element.videoAdIdsResponsive.map((x)=>{context.videosAdsURL.push(`https://www.youtube.com/embed/${x}`)});
        }
        if (element.imageAdUrlsResponsive.length > 0) {
          context.adBannerImage = element.imageAdUrlsResponsive.map((x)=>x);
        }
      });

      // AUDIENCE
      (googleDisplay ? googleDisplay.audiences.splice(0, 5) : []).forEach(
        element => {
          context.audienceInteractionSeries.push(element.impressions);
          context.audienceInteractionChartOptions.labels.push(
            element.criteria
          );
        }
      );

      context.campaignData = objCampaigns;
      context.adSites = objAdSites.sort((firstValue,secondValue)=> secondValue.impressions - firstValue.impressions);

      context.adsBanners = objAdsBanners;
      context.Product = product;

      if (context.adBannerImage) {
        context.adBannerImage.map(x => {
          objAdsBanners.push({
            bannerURL: x,
            itemCode: "300 x 250"
          });
        });
      }

      if (context.adSites.length > 8) {
        context.showMessage = true;
      }
    },
    handleClick(tab) {
      const pane = tab.$el.id;
      if (pane == "pane-first") {
        this.campaignType = this.campaignTypes.Portales;
      } else if (pane == "pane-second") {
        this.campaignType = this.campaignTypes.Aplicaciones;
      } else {
        this.campaignType = this.campaignTypes.Responsive;
      }
      const context = this;
      this.objAdSites = [];
      this.adSites = [];
      this.adsBanners = [];
      this.Product.impressions = [];
      this.Product.clicks = [];
      this.reload(context);
    },
    numberLetter(value) {
      let suffixes = [
        "U",
        "D",
        "C",
        "K",
        "K",
        "K",
        "M",
        "M",
        "M",
        "B",
        "B",
        "B",
        "T",
        "T",
        "T"
      ];

      let stringValue = value.toString();
      let valueLength = stringValue.length;
      let suffix = suffixes[valueLength - 1];

      const BASEDIVISOR = 3;
      let startindex = 0;
      let characterToTake = valueLength % BASEDIVISOR;
      characterToTake = characterToTake == 0 ? BASEDIVISOR : characterToTake;

      if (valueLength > BASEDIVISOR) {
        let wholePart = stringValue.substr(startindex, characterToTake);
        let decimalPart = stringValue.substr(
          startindex + characterToTake,
          BASEDIVISOR
        );

        let firstDecimal = decimalPart.substr(startindex, 1);

        let wholeNumber =
          firstDecimal != "0"
            ? wholePart + "." + decimalPart.substr(startindex, 1) + suffix
            : wholePart + suffix;

        return wholeNumber;
      }

      return stringValue;
    },

    collapse() {
      if (this.mas === 8) {
        this.mas = 80;
        this.masApp = 20;
        this.Message = "menos -";
      } else if (this.mas > 9) {
        this.mas = 8;
        this.masApp = 8;
        this.Message = "más +";
      }
    }
  },
  computed: {
    ...mapGetters(["date1", "date2", "products"])
  }
};
</script>
<style lang="scss" scoped>
.mobile-canvas img {
  width: 277px;
}
.el-tab-pane,
.product-view-all {
  justify-content: center;
}
.el-tabs__nav {
  margin-left: 50%;
}
.export {
  display: none;
}
.nameSite {
  white-space: nowrap;
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.show {
  background: linear-gradient(0deg, #fff, #fff 70%, hsla(0, 0%, 100%, 0));
  color: $link-color;
  font-size: 12px;
  margin: 0 45%;
}
.logo {
  width: 106px;
  height: 50px;
}
.product-view {
  .two-column {
    display: grid;
  }
}
.youtube-header {
  width: 100%;
  height: 45px;
  background-color: #282828;
  border-radius: 5px 5px 0px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: $white;
  padding: 0px 20px;
  box-sizing: border-box;
  img {
    width: 65px;
  }
  svg {
    margin-left: 10px;
  }
}
.youtube-viewport {
  width: 100%;
  height: 160px;
}
.ads-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  .widget.ad-views[data-v-7d0073fa] {
    grid-column: 1 / 1;
  }
}

.ad-sites-wrapper {
  text-align: center;
  .sites {
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid $blueish-gray-200;
    &:last-child {
      margin-bottom: 0px;
      padding-bottom: 0px;
      border-bottom: none;
    }
    h4 {
      color: $blueish-gray-700;
    }
    .site-data {
      display: grid;
      grid-template-columns: 1fr 1fr;
      margin-top: 15px;
      h6 {
        color: $blueish-gray-600;
      }
      p {
        color: $blueish-gray-400;
      }
    }
  }
}

.youtube-wrapper {
  .el-tabs__nav {
    float: none;
    text-align: center;
  }
}

@include respond-above(md) {
  .carousel-youtube {
    .el-carousel__container {
      min-height: 340px;
    }
  }
  .youtube-wrapper {
    .el-tabs__item {
      padding: 0px 100px !important;
    }
  }
}

.widget {
  &.widget-goals {
    .card-goals {
      .card-content {
        text-align: center;
        h1 {
          span {
            font-size: 35px;
          }
          font-size: 52px;
          font-weight: $font-medium;

          color: $highlight-color;
        }
      }
    }
  }
  &.brand-impact {
    .card-line-chart {
      .card-top {
        .card-number {
          text-align: center;
          h3 {
            color: $highlight-color;
          }
        }
      }
    }
  }
}

@include respond-above(sm) {
  .ad-sites-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 30px;
    .sites {
      .site-data {
        margin-top: 5px;
      }
    }
  }
  .ads-container {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    .widget.ad-views[data-v-7d0073fa] {
      grid-column: 1 / 1;
    }
  }
  .widget {
    &.widget-goals {
      .cards-wrapper {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 20px;
      }
    }
  }
}

.demographic-data {
  h5 {
    font-size: 16px;
    color: $blueish-gray-600;
  }
}
.el-tab-pane,
.product-view-all {
  display: grid;
  grid-template-columns: 2fr 1fr;
  max-width: 1000px;
  margin: 0 auto;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}

@include respond-above(md) {
  .product-view {
    max-width: 1000px;
    margin: 0 auto;
    .two-column {
      grid-column: 1 / -1;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 20px;
    }
    .widget-look {
      grid-row: 1 / -1;
      grid-column: 2;
    }
    .widget {
      &.keyword-widget,
      &.campaign-widget,
      &.ad-sites-widget {
        grid-column: 1 / -1;
      }
    }
    .separator {
      grid-column: 1 / -1;
      margin-bottom: 20px;
    }
    .ads-container {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      .widget.ad-views[data-v-7d0073fa] {
        grid-column: 1 / 1;
      }
    }
    .demographic-data {
      grid-column: 1 / -1;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 30px;
      & > .widget-title {
        text-align: center;
        grid-column: 1 / -1;
        margin-bottom: 30px;
      }
      .widget:nth-child(4) {
        grid-column: 1 / -1;
      }
    }
    .ad-views {
      grid-column: 1 / -1;
      .cards-wrapper {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 30px;
      }
    }
  }

  .ad-sites-wrapper {
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    .sites {
      border-right: 1px solid $blueish-gray-200;
      border-bottom: none;
      padding-bottom: 0px;

      &:nth-child(4n) {
        border-right: none;
      }
    }
  }
}

// loading

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-ellipsis div {
  position: absolute;
  top: 27px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #3576ff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 6px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 6px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 26px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 45px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(19px, 0);
  }
}
</style>
